import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import callApi from '../../../utils/callApi';
import { Redirect } from '../../../utils/checkoutState';
import { config, getAssetUrl } from '../../../utils/config';
import redirect from '../../../utils/redirect';
import Button from '../../atoms/Button';
import SubHeadline from '../../atoms/SubHeadline';
import { showDefaultError } from '../../molecules/Notifications';
import './style.scss';

type PaymentConfirmationPollingResponse = {
  status: 'pending' | 'success' | 'failed';
  redirect?: Redirect;
};

const PaymentConfirmationPending = () => {
  const [status, setStatus] = useState<'pending' | 'failed' | 'timeout'>('pending');

  const onBackToShoppingClicked = () => (window.location.href = '/');

  useEffect(() => {
    (async () => {
      let shouldPoll = true;
      let hasTimedOut = false;
      setTimeout(() => (hasTimedOut = true), config.paymentConfirmationPollTimeout);
      while (shouldPoll) {
        try {
          const paymentConfirmationPollingResponse = await callApi<PaymentConfirmationPollingResponse>({
            endpoint: '/state/order/confirmation/status',
            allowedStatusCodes: [424],
          });
          if (paymentConfirmationPollingResponse.status === 'success') {
            redirect(paymentConfirmationPollingResponse.redirect!);
            shouldPoll = false;
          } else if (paymentConfirmationPollingResponse.status === 'failed') {
            setStatus('failed');
            shouldPoll = false;
          } else if (hasTimedOut) {
            setStatus('timeout');
            shouldPoll = false;
          }
        } catch (e) {
          console.error(e);
          showDefaultError();
        }
      }
    })();
  }, []);

  return (
    <>
      <div className="payment-status-container">
        {status === 'pending' && (
          <div>
            <img className="img-responsive" src={getAssetUrl('payment/confirmationPending/pending.gif')} />
            <SubHeadline>
              <FormattedMessage id="payment.status.pending" />
            </SubHeadline>
          </div>
        )}
        {status === 'failed' && (
          <div>
            <img className="img-responsive" src={getAssetUrl('payment/confirmationPending/failed.gif')} />
            <SubHeadline>
              <FormattedMessage id="payment.status.failed" />
            </SubHeadline>
            <Button onClick={onBackToShoppingClicked}>
              <FormattedMessage id="payment.status.buttonToAccount" />
            </Button>
          </div>
        )}
        {status === 'timeout' && (
          <div>
            <img className="img-responsive" src={getAssetUrl('payment/confirmationPending/pending.gif')} />
            <SubHeadline>
              <FormattedMessage id="payment.status.timeout" />
            </SubHeadline>
            <Button onClick={onBackToShoppingClicked}>
              <FormattedMessage id="auth.backToShopping" />
            </Button>
          </div>
        )}
      </div>
    </>
  );
};

export default PaymentConfirmationPending;
